import {
    each,
    isPlain
} from './obj';
function mergeOptions() {
    var result = {};
    for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
        sources[_key] = arguments[_key];
    }
    sources.forEach(function (source) {
        if (!source) {
            return;
        }
        each(source, function (value, key) {
            if (!isPlain(value)) {
                result[key] = value;
                return;
            }
            if (!isPlain(result[key])) {
                result[key] = {};
            }
            result[key] = mergeOptions(result[key], value);
        });
    });
    return result;
}
export default mergeOptions;